import React from "react";
import { Alert } from "reactstrap";

import {
  EDIT_BANNER_PUBLISHED,
  EDIT_BANNER_QUESTIONS_LOCKED,
  EDIT_BANNER_SHARED,
} from "./editCopy";

// Read-only notice shown at the bottom of the Edit page's right column.
// Ported as-is from both edit bodies, including branches Messages cannot reach.
const EditStatusBanner = ({ isPublished, questionEditable, isShared }) => {
  if (isShared) {
    return (
      <Alert color="success" className="text-center bwai-edit-status-banner">
        {EDIT_BANNER_SHARED}
      </Alert>
    );
  }

  if (isPublished) {
    return (
      <Alert color="success" className="text-center bwai-edit-status-banner">
        {EDIT_BANNER_PUBLISHED}
      </Alert>
    );
  }

  if (!questionEditable) {
    return (
      <Alert color="success" className="text-center bwai-edit-status-banner">
        {EDIT_BANNER_QUESTIONS_LOCKED}
      </Alert>
    );
  }

  return "";
};

export default EditStatusBanner;
